import { AUTH_TOKEN } from "../react-admin/auth-provider";
import { $axios } from "../utils/axios";

export async function create_offer(applicationId: string, payload: any) {
    return $axios.post(`/admin/applications/${applicationId}/offer`, payload, {
        headers: {
            authorization: localStorage.getItem(AUTH_TOKEN) ?? "",
        },
    });
}
